import { useEffect } from "react";

const useAuthGuard = ({ forAdmin = false } = {}) => {
  useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");
    const customerToken = localStorage.getItem("token");

    const isLoggedIn = forAdmin ? adminToken : customerToken || adminToken;

    if (!isLoggedIn) {
      window.location.href = forAdmin
        ? "/login"
        : "/stringing/customer/login";
    }
  }, [forAdmin]);
};

export default useAuthGuard;
